import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/element-overrides.css";
import router from "./router/index";
import "@/assets/css/iconfont/iconfont.css";
import store from "./store";

import '@umoteam/editor/style'
Vue.use(ElementUI);
console.log(ElementUI.version); 
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
